import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
@Pipe({
  name: 'crmFullPathTransPipe',
})
export class FullPathTransPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(scope: string, key: string, param: Object = {}): string {
    return this.translocoService.translate(`${scope}.${key}`, param);
  }
}
